export const services = [
  {
    id: 1,
    title: "Technical Projects & Assignments Support",
    description: "Complete coding projects, assignments, and research work with expert guidance and mentorship.",
    icon: "🛠️",
    color: "bg-blue-500",
    category: "Project Support",
    pricing: {
      hourly: "$15-35/hour",
      project: "Custom pricing",
      packages: [
        { name: "Small Project", price: "$50-70", duration: "1-3 days" },
        { name: "Medium Project", price: "$100-150", duration: "1-2 weeks" },
        { name: "Large Project", price: "$400+", duration: "2+ weeks" }
      ]
    },
    features: [
      "Complete project development",
      "Code review and optimization",
      "Architecture and design guidance",
      "Best practices implementation",
      "Documentation and comments",
      "Testing and debugging",
      "Deployment assistance",
      "Mentorship throughout process"
    ],
    deliverables: [
      "Fully functional code",
      "Comprehensive documentation",
      "Code review report",
      "Best practices guide",
      "Testing suite",
      "Deployment instructions"
    ],
    technologies: ["Python", "JavaScript", "React", "Node.js", "Django", "Flask", "SQL", "MongoDB", "AWS", "Docker"],
    suitableFor: ["Students", "Professionals", "Researchers", "Startups", "Small Businesses"],
    process: [
      "Initial consultation and requirements analysis",
      "Project planning and timeline creation",
      "Regular progress updates and feedback",
      "Code development with best practices",
      "Testing and quality assurance",
      "Documentation and handover"
    ]
  },
  {
    id: 2,
    title: "Technical Writing",
    description: "Professional documentation, blog posts, research papers, and technical reports for programming and tech topics.",
    icon: "📝",
    color: "bg-green-500",
    category: "Content Creation",
    pricing: {
      hourly: "$15-30/hour",
      project: "Custom pricing",
      packages: [
        { name: "Blog Post", price: "$50-80", duration: "1-2 days" },
        { name: "Technical Doc", price: "$100-200", duration: "2-5 days" },
        { name: "Research Paper", price: "$300-500", duration: "1-2 weeks" }
      ]
    },
    features: [
      "Technical documentation",
      "API documentation",
      "Blog posts and articles",
      "Research papers",
      "User guides and tutorials",
      "Code comments and README files",
      "Technical reports",
      "White papers"
    ],
    deliverables: [
      "Well-structured content",
      "Proper formatting and styling",
      "Technical accuracy review",
      "SEO optimization",
      "Plagiarism-free content",
      "Multiple revision rounds"
    ],
    technologies: ["Markdown", "GitBook", "Sphinx", "Jekyll", "WordPress", "Medium", "Dev.to", "GitHub"],
    suitableFor: ["Developers", "Technical Writers", "Researchers", "Companies", "Open Source Projects"],
    process: [
      "Topic research and outline creation",
      "Content writing with technical accuracy",
      "Review and fact-checking",
      "Formatting and styling",
      "SEO optimization",
      "Final review and delivery"
    ]
  },
  {
    id: 3,
    title: "Code Debugging & Optimization",
    description: "Expert debugging services to fix bugs, optimize performance, and refactor code for better maintainability.",
    icon: "🐛",
    color: "bg-red-500",
    category: "Code Quality",
    pricing: {
      hourly: "$12-25/hour",
      project: "Custom pricing",
      packages: [
        { name: "Quick Fix", price: "$20-30", duration: "1-2 hours" },
        { name: "Deep Debug", price: "$40-60", duration: "4-8 hours" },
        { name: "Full Optimization", price: "$100-150", duration: "1-2 days" }
      ]
    },
    features: [
      "Bug identification and fixing",
      "Performance optimization",
      "Code refactoring",
      "Memory leak detection",
      "Security vulnerability assessment",
      "Code quality improvement",
      "Live debugging sessions",
      "Detailed explanation and learning"
    ],
    deliverables: [
      "Fixed and optimized code",
      "Detailed bug report",
      "Performance analysis",
      "Refactoring recommendations",
      "Code quality metrics",
      "Learning materials and explanations"
    ],
    technologies: ["Python", "JavaScript", "Java", "C++", "C#", "Go", "Rust", "SQL", "React", "Node.js"],
    suitableFor: ["Developers", "Students", "Companies", "Open Source Contributors", "Freelancers"],
    process: [
      "Code analysis and problem identification",
      "Debugging strategy development",
      "Systematic bug fixing",
      "Performance testing and optimization",
      "Code refactoring and improvement",
      "Documentation and explanation"
    ]
  },
  {
    id: 4,
    title: "1-on-1 Interview Preparation",
    description: "Personalized coding interview prep for Software Engineer, Backend Developer, and DevOps Engineer roles.",
    icon: "🎯",
    color: "bg-purple-500",
    category: "Career Development",
    pricing: {
      hourly: "$25-40/hour",
      project: "Custom pricing",
      packages: [
        { name: "Mock Interview", price: "$50-80", duration: "2 hours" },
        { name: "Prep Session", price: "$100-150", duration: "4-6 hours" },
        { name: "Complete Prep", price: "$200-500", duration: "2-3 weeks" }
      ]
    },
    features: [
      "Mock coding interviews",
      "Algorithm and data structure practice",
      "System design preparation",
      "Behavioral interview coaching",
      "Resume and portfolio review",
      "Company-specific preparation",
      "Salary negotiation guidance",
      "Follow-up support"
    ],
    deliverables: [
      "Personalized study plan",
      "Practice problems and solutions",
      "Interview feedback and scores",
      "Resume optimization",
      "Portfolio recommendations",
      "Company research and insights"
    ],
    technologies: ["Python", "JavaScript", "Java", "C++", "System Design", "Databases", "Cloud Platforms", "DevOps Tools"],
    suitableFor: ["Job Seekers", "Career Changers", "Recent Graduates", "Experienced Developers", "Bootcamp Graduates"],
    process: [
      "Initial assessment and goal setting",
      "Customized study plan creation",
      "Technical skill practice sessions",
      "Mock interview simulations",
      "Feedback and improvement sessions",
      "Final preparation and confidence building"
    ]
  }
];

export const serviceCategories = [
  {
    name: "Project Support",
    description: "Complete development and technical project assistance",
    services: [1],
    icon: "🛠️"
  },
  {
    name: "Content Creation",
    description: "Technical writing and documentation services",
    services: [2],
    icon: "📝"
  },
  {
    name: "Code Quality",
    description: "Debugging, optimization, and code improvement",
    services: [3],
    icon: "🐛"
  },
  {
    name: "Career Development",
    description: "Interview prep and career advancement",
    services: [4],
    icon: "🎯"
  }
];

export const serviceTestimonials = [
  {
    id: 1,
    name: "Alex Chen",
    role: "Computer Science Student",
    service: "Technical Projects & Assignments Support",
    content: "Duke helped me complete my final year project on machine learning. His guidance on best practices and code structure was invaluable. I learned so much more than just getting the project done!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    role: "Technical Writer",
    service: "Technical Writing",
    content: "Duke's technical writing service helped me create comprehensive API documentation for our startup. The quality was exceptional and saved us weeks of work. Highly recommended!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80"
  },
  {
    id: 3,
    name: "Mike Rodriguez",
    role: "Software Developer",
    service: "Code Debugging & Optimization",
    content: "I was stuck on a complex bug for days. Duke not only fixed it but also explained the root cause and how to prevent similar issues. The live debugging session was incredibly helpful.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80"
  },
  {
    id: 4,
    name: "Emily Wang",
    role: "Recent Graduate",
    service: "1-on-1 Interview Preparation",
    content: "Duke's interview prep helped me land my dream job at a FAANG company. The mock interviews and personalized feedback were exactly what I needed to build confidence and improve my skills.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80"
  }
];

export const serviceFAQs = [
  {
    question: "How quickly can you complete a project?",
    answer: "Project timelines vary based on complexity. Small projects (1-3 days), medium projects (1-2 weeks), and large projects (2+ weeks). I provide detailed timelines during the initial consultation."
  },
  {
    question: "Do you work with specific programming languages?",
    answer: "I work with Python, JavaScript, React, Node.js, Django, Flask, SQL, MongoDB, AWS, Docker, and many other technologies. If you have specific requirements, let me know during consultation."
  },
  {
    question: "Can you help with academic assignments?",
    answer: "Yes, I provide guidance and assistance with academic projects while ensuring you understand the concepts and learn best practices. I focus on teaching rather than just completing work."
  },
  {
    question: "What's included in technical writing services?",
    answer: "Technical writing includes documentation, blog posts, research papers, API docs, user guides, and more. All content is original, well-researched, and optimized for your target audience."
  },
  {
    question: "How do debugging sessions work?",
    answer: "I offer both live debugging sessions (screen sharing) and code review services. I'll identify issues, fix bugs, optimize performance, and explain everything in detail so you learn from the process."
  },
  {
    question: "What's included in interview preparation?",
    answer: "Interview prep includes mock interviews, algorithm practice, system design preparation, behavioral coaching, resume review, and company-specific guidance. I tailor the approach to your target roles."
  }
];
